import site from '../data/site';
import './ContactBlock.css';

export default function ContactBlock({ variant = 'light' }) {
  const className = `cb cb--${variant}`;
  return (
    <div className={className}>
      <div className="cb__row">
        <span className="cb__icon" aria-hidden="true">📍</span>
        <div>
          <h4>Address</h4>
          <a href={site.address.mapsUrl} target="_blank" rel="noopener noreferrer">
            {site.address.line1}<br/>{site.address.line2}
          </a>
        </div>
      </div>

      <div className="cb__row">
        <span className="cb__icon" aria-hidden="true">📞</span>
        <div>
          <h4>Phone</h4>
          {site.phones.map((p) => (
            <a key={p.tel} href={`tel:${p.tel}`} className="cb__phone">{p.display}</a>
          ))}
        </div>
      </div>

      <div className="cb__row">
        <span className="cb__icon" aria-hidden="true">🕒</span>
        <div>
          <h4>Hours</h4>
          <p>{site.hours.summary}</p>
          <p className="cb__closed">{site.hours.closedNote}</p>
        </div>
      </div>
    </div>
  );
}
